import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import Dropdown from 'shared/components/ui/DropDown/DropDown';
import { IBadgeSelect } from 'shared/components/ui/badge-select/badge-select';

import ArrowDown from 'assets/arrow-down.svg?react';
import CurrencyIcon from 'assets/currency-small.svg?react';

export const BadgeSelectMobile = ({
  value,
  setValue,
  icon,
  options = [],
  className,
}: IBadgeSelect) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleOpen = () => setOpen(!open);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={containerRef} className={clsx('relative cursor-pointer', className)}>
      <div
        className="text-opacity-70` flex min-w-[4.875rem] flex-col gap-1 text-sm text-white text-opacity-70"
        onClick={toggleOpen}
      >
        <div className="flex items-center gap-1">
          <span>Currency</span>
          <CurrencyIcon className="h-3 w-3" />
        </div>

        <div className="flex gap-1 text-md text-light-grape">
          {icon && <span className="h-4 w-4">{icon}</span>}
          {t(options.find((option) => option.value === value)?.label || '')}
          <ArrowDown
            className={`w-3 transition-transform duration-300 ${open ? 'rotate-180 transform' : ''}`}
          />
        </div>
      </div>
      <Dropdown
        open={open}
        list={[...options]}
        onClick={(option) => {
          toggleOpen();
          setValue(String(option.value));
        }}
        position={{ top: 40, left: 0 }}
      />
    </div>
  );
};
